// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"581":"c3d87c68","839":"ecce0ecf"}[chunkId] + ".chunk.js";
};